import styled from "styled-components";

export const PlayersWidgetsContainerStyle = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
    width: 100%;
    .industry-leaders-players-widget-header-cell {
        font-weight: 500;
        font-size: 12px;
        height: 32px;
        padding: 0 18px 0 18px;
        display: flex;
        align-items: center;
        > div {
            width: 100%;
        }
    }

    .industry-leaders-players-widget-row-cell {
        height: 39px;
        padding: 0 18px 0 18px;
        display: flex;
        align-items: center;
        > div {
            width: 100%;
        }
        &:last-child {
            border-bottom: none;
        }
    }
`;
